import React from "react";
import { CheckCircle2, AlertTriangle, XCircle, Info, X } from "lucide-react";

export default function ToastComponent({ visible, message, type = "warning", onClose }) {
    const colorClasses = {
        success: {
            bar: "border-green-500",
            iconWrap: "bg-green-100 text-green-700",
            icon: <CheckCircle2 className="h-5 w-5" />,
        },
        error: {
            bar: "border-red-500",
            iconWrap: "bg-red-100 text-red-700",
            icon: <XCircle className="h-5 w-5" />,
        },
        warning: {
            bar: "border-yellow-500",
            iconWrap: "bg-yellow-100 text-yellow-700",
            icon: <AlertTriangle className="h-5 w-5" />,
        },
        info: {
            bar: "border-blue-500",
            iconWrap: "bg-blue-100 text-blue-700",
            icon: <Info className="h-5 w-5" />,
        },
    }[type] || {
        bar: "border-gray-400",
        iconWrap: "bg-gray-100 text-gray-700",
        icon: <Info className="h-5 w-5" />,
    };

    return (
        <div
            className={`fixed top-6 right-6 mt-16 z-[1000] transform transition-all duration-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-3 pointer-events-none'
                }`}
            aria-live="polite"
            aria-atomic="true"
        >
            <div className={`max-w-sm rounded-lg shadow-lg border bg-white border-gray-200 ${colorClasses.bar} border-l-4`}>
                <div className="px-4 py-3 flex items-center gap-3">
                    <div className={`flex h-8 w-8 items-center justify-center rounded-full ${colorClasses.iconWrap}`}>
                        {colorClasses.icon}
                    </div>
                    <div className="text-sm text-gray-800 whitespace-pre-line leading-5 pr-6">
                        {message}
                    </div>
                    <button
                        onClick={onClose}
                        className="ml-auto text-gray-400 hover:text-gray-600 transition-colors"
                        aria-label="Close"
                        title="Close"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}


